import { Button } from '@ui'
import { Route } from 'next'
import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import browserEnv from '~/libs/env/browserEnv'
import { sendLog } from '~/libs/ga'

const ADJUST_URL =
  'https://samansa.go.link/samansa.com?adj_t=20bsz5s2&adj_campaign=fixedInstallPrompt_fixed'
const ADJUST_BLANK_URL = 'https://samansa.go.link/samansa.com?adj_t='

type Props = {
  variant?: 'contained' | 'outlined'
}

export const AppOpenButton = ({ variant = 'contained' }: Props) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { t } = useTranslation()

  const appLink = useMemo(() => {
    const deepLinkUrl = `${browserEnv.NEXT_PUBLIC_APP_LINK}${pathname}${
      searchParams && searchParams.toString() ? `?${searchParams}` : ''
    }`

    const adjT = searchParams.get('adj_t')
    if (adjT) {
      return ADJUST_BLANK_URL + adjT + `&deep_link=${encodeURIComponent(deepLinkUrl)}`
    }

    return ADJUST_URL + `&deep_link=${encodeURIComponent(deepLinkUrl)}`
  }, [pathname, searchParams])

  return (
    <Link
      href={appLink as Route}
      passHref
      style={{ width: '100%', textDecoration: 'none', flex: 1 }}
    >
      <Button
        variant={variant}
        fullWidth
        onClick={() => {
          sendLog({
            screen: 'app_open_modal_v2',
            action: 'open_app',
          })
        }}
      >
        {t('open_app')}
      </Button>
    </Link>
  )
}
